/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/commonClasses/commonSectionBase.ts" />

module Meevo.Plugins.WalkinManagerSettings {
    "use strict";

    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import NotificationTags = Meevo.Components.Common.NotificationTags;

    /**
     * Base Section of WalkIn Manager Settings
     */
    export class BaseSection extends Meevo.Components.CommonClasses.SettingsSectionBase {
        public isInDev: boolean;
        public tags: Array<string>;
        public availableMinuteValues: Array<number>;
        public availablePositions: Array<number>;
        public charLimit: number;
        public increasedCharLimit: number;

        constructor(params: Meevo.Model.ISectionParamsWalkinManagerSettings) {
            const {sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud,
                baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, modalService, sectionSecurityKey} = params;

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud,
                baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, modalService, sectionSecurityKey);

            this.isInDev = true; // disable features that not implemented
            this.tags = [
                NotificationTags.WALKIN_POSITION,
                NotificationTags.WALKIN_ETA,
                NotificationTags.CLIENT_FIRSTNAME,
                NotificationTags.WALKIN_URL,
                NotificationTags.EMPLOYEE,
                NotificationTags.SERVICE,
                NotificationTags.BUSINESS_NAME
            ];
            this.availableMinuteValues = [];
            this.availablePositions = [2, 3, 4, 5, 6, 7, 8, 9, 10];
            this.charLimit = 160;
            this.increasedCharLimit = 200;
        }

        /**
         * Prepare model to save
         * @returns {Meevo.Model.IWalkInSettings} model
         * */
        public preSave (): Meevo.Model.IWalkInSettings {
            return this.model;
        }

        /**
         * Convert boolean to object state enum
         * @param {boolean} value
         * @returns {ObjectStateEnum} converted value
         * */
        protected convertBooleanToObjectState (value: boolean) : ObjectStateEnum {
            if (value) {
                return ObjectStateEnum.Active;
            } else {
                return ObjectStateEnum.Inactive;
            }
        }

        /**
         * Convert object state enum to boolean
         * @param {ObjectStateEnum} value
         * @returns {boolean} converted value
         * */
        protected convertObjectStateToBoolean (value: ObjectStateEnum) : boolean {
            return value === ObjectStateEnum.Active;
        }

        /**
         * Reset notification message to default
         * @param {string} notificationName - notification name
         * */
        public resetNotification (notificationName): void {
            this.model.notifications[notificationName] = this.model.systemNotifications[notificationName];

            if (notificationName === 'notificationClosingXText') {
                this.model.notificationClosingMins = 30;
            }
        }
    }

}